export default __webpack_public_path__ + "static/media/slider-img16.6149e5dc.jpg";